import type { AdminOpenClaw } from "../../../types/openclaw";
import { healthStateLabel } from "../HealthStrip";
import styles from "./instanceDetail.module.css";

// Same precedence as the Instances table's status cell: Stopped (EC2 off) >
// provisioning lifecycle (not yet RUNNING) > runtime health.
export const StatusBadge = ({ claw }: { claw: AdminOpenClaw }): JSX.Element => {
  if (claw.stopped) {
    return <span className={`${styles.badge} ${styles.badge_stopped}`}>Stopped</span>;
  }
  if (claw.status === "RESIZING") {
    return <span className={`${styles.badge} ${styles.badge_resizing}`}>Resizing</span>;
  }
  if (claw.status !== "RUNNING") {
    const cls = claw.status === "FAILED" ? styles.badge_failed : styles.badge_provisioning;
    const label = claw.status === "FAILED" ? "Provisioning failed" : "Provisioning";
    return <span className={`${styles.badge} ${cls}`}>{label}</span>;
  }
  const state = claw.health?.state ?? null;
  const tone =
    state === "HEALTHY" ? styles.badge_healthy
      : state === "DEGRADED" ? styles.badge_degraded
        : state === "DOWN" || state === "UNREACHABLE" ? styles.badge_down
          : styles.badge_none;
  return <span className={`${styles.badge} ${tone}`}>{healthStateLabel(state)}</span>;
};
